var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('code-scanner',{attrs:{"readerTypes":_vm.readerTypes},on:{"onDetected":_vm.detected}})}
var staticRenderFns = []

export { render, staticRenderFns }